import React, { useState } from "react";
import Footer from "../component/Footer";
import {
  ClockIcon,
  UserIcon,
  UsersIcon,
  WindowIcon,
} from "@heroicons/react/20/solid";
import CTA from "../component/CTA";
import { BsCheck2, BsFillPeopleFill, BsFillPersonFill } from "react-icons/bs";
import { GoPrimitiveDot } from "react-icons/go";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Tab } from "@headlessui/react";
import { HiArrowUpRight } from "react-icons/hi2";
import { Link } from "react-router-dom";
import Modal from "../component/Modal";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Courses1() {
  const [selectedItem, setSelectedItem] = useState({});
  const [type, setType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const features = [
    {
      name: "สอนโดยทีมอาจารย์ผู้เชี่ยวชาญ",
      description:
        "เรียนตัวต่อตัวกับอาจารย์ผู้สอน ปรับแต่งกำหนดบทเรียนที่เหมาะสม เลือกเวลาเรียนเอง",
      icon: UserIcon,
    },
    {
      name: "จัดเวลาเรียนเองได้",
      description:
        "สามารถเรียนเวลาไหนก็ได้ น้องๆสามารถเลือกเวลาเรียนเองได้ ตามความเหมาะสมกับไลพ์สไตล์ตัวเอง",
      icon: ClockIcon,
    },
    {
      name: "เรียนคลาสส่วนตัว",
      description:
        "เรียนตัวต่อตัวกับอาจารย์ผู้สอน ปรับแต่งกำหนดบทเรียนที่เหมาะสม เลือกเวลาเรียนเอง",
      icon: UsersIcon,
    },
    {
      name: "เรียนออนไลน์ได้ทุกที่",
      description:
        "เรียนที่ไหนก็ได้ผ่าน application สะดวกสบาย ยืดหยุ่นเวลาได้มากขึ้น",
      icon: WindowIcon,
    },
  ];
  let [courses] = useState({
    IGCSE: [
      {
        id: 1,
        name: "IGCSE",
        description:
          "IGCSE (International General Certificate of Secondary Educational) เป็นหลักสูตรการสอบเทียบวุฒิมัธยมศึกษาตอนปลาย จากประเทศอังกฤษ ซึ่งหลักสูตรเป็นที่ยอมรับในระดับนานาชาติ ใช้ระยะเวลาเรียน 2 ปี โดยเป็นหลักสูตรของนักเรียนอายุ 14 – 16 ปี ที่ต้องสอบให้ผ่านอย่างน้อย 5 วิชา ในช่วง year 10 และ 11 ซึ่งกระทรวงศึกษาฯ ของไทยจะรับรองวุฒิให้เทียบเท่าวุฒิ ม.6 ก็ต่อเมื่อนักเรียนสอบ AS หรือ A-LEVEL เพิ่มอีก 3 วิชา จึงจะสามารถนำวุฒิไปสมัครเรียนต่อในระดับมหาวิทยาลัยได้",

        imgUrl: "./img/igcse.jpg",
        href: "https://en.wikipedia.org/wiki/International_General_Certificate_of_Secondary_Education",
        level: ["Year 7 - 8", "Year 9 - 11"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนเข้า IGCSE", "IGCSE "],
        subjects: [
          ["Basic Math", "Basic Science"],
          [
            "Math",
            "Eng-SL",
            "Biology",
            "Physics",
            "Economic",
            "Fur-Math",
            "Chemistry",
          ],
        ],
      },
    ],
    "A-LEVEL": [
      {
        id: 1,
        name: "A-LEVEL",
        description:
          "ระบบการศึกษาของอังกฤษ เพื่อเตรียมตัวสู่การเรียนระดับมหาวิทยาลัย ประกาศของกระทรวงศึกษาธิการเมื่อปี 2565 ผลสอบ A-Level 3 วิชา (ไม่ต่ำกว่า E) เมื่อรวมกับผลสอบ IGCSE 5 วิชา (ไม่ต่ำกว่า C) สามารถเทียบวุฒิเท่ากับ ม.6 ได้ A-Level มีวัตถุประสงค์เพื่อเตรียมความพร้อมและความรู้ที่จำเป็นสำหรับการศึกษาต่อในระดับมหาวิทยาลัย โดยใช้ระยะเวลาในการเรียน 2 ปี โดย A-Level มีเนื้อหาที่หลากหลายเพื่อให้นักเรียนเลือกวิชาที่ถนัดเพื่อเตรียมความพร้อมสำหรับการเรียนในมหาวิทยาลัยต่อไป",
        subjects: [["Chemistry", "Math", "Economic", "Biology", "Physics"]],

        imgUrl: "./img/blog.jpg",
        href: "https://en.wikipedia.org/wiki/A-Level",
        level: ["Year 12 - 13"],
        course: ["A-Level"],
      },
    ],
    IB: [
      {
        id: 1,
        name: "IB",
        description:
          "IB (International Baccalaureate) คือ หลักสูตรที่ประยุกต์จากระบบการศึกษาต่างๆทั่วโลก เพื่อที่จะเอาคะแนนไปยื่นเข้าสอบหรือสมัครเรียนต่อในมหาวิทยาลัยต่างๆทั่วโลก ใช้แพร่หลายทั่วโลกมากกว่า 125 ประเทศ วัตถุประสงค์ของการก่อตั้งหลักสูตรนี้ก็เพื่อให้มีระบบการศึกษาในรูปแบบใหม่ที่เป็นที่ยอมรับจากมหาวิทยาลัยทั่วโลก โดยใช้เวลาเรียนทั้งหมด 2 ปี (2 ปีสุดท้ายก่อนเรียนจบ High school) โดยหลักสูตรนี้จะสอนให้นักเรียนในระบบฝึกคิดเชิงวิพากษ์ ควบคู่ไปกับการศึกษาวัฒนธรรมอื่นๆ ผ่านการเรียนภาษานั้นๆ นักเรียนที่ผ่านการเรียนการสอนระบบ IB จึงมีทักษะที่จะเป็นผู้ริเริ่มที่คำนึงถึงความแตกต่างของวัฒนธรรมในอนาคตได้อย่างดี",
        subjects: [["Chemistry", "Math", "Biology", "Physics"]],

        imgUrl: "./img/blog.jpg",
        href: "https://th.wikipedia.org/wiki/International_Baccalaureate",
        level: ["Year 12 - 13"],
        course: ["IB"],
      },
    ],
    AP: [
      {
        id: 1,
        name: "AP",
        description:
          "Advanced Placement หรือ การสอบ AP คือ ประเภทของการทดสอบเพื่อเตรียมความพร้อมในการเข้าเรียนระดับปริญญาตรี เป็นหลักสูตรของทางสหรัฐฯ ดำเนินการโดย College Board หน่วยงานเดียวกับการออกข้อสอบ SAT แนวทางจะถูกใช้สำหรับคนที่เรียนโครงการหลักสูตรล่วงหน้าในระดับมัธยมปลาย ส่วนมากหลักสูตร AP มักนิยมใช้กับกลุ่มโรงเรียนนานาชาติ โรงเรียนอินเตอร์ในประเทศไทย",
        subjects: [
          ["Basic Math", "Basic Science"],
          ["Chemistry", "Math", "Biology", "Physics"],
        ],

        imgUrl: "./img/blog.jpg",
        href: "https://en.wikipedia.org/wiki/Advanced_Placement",
        level: ["Grade 6 - 8", "Grade 9 - 12"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนสอบ AP", "AP "],
      },
    ],
    "SAT I": [
      {
        id: 1,
        name: "SAT I",
        description:
          "SAT คือ ข้อสอบที่ใช้ทดสอบการใช้เหตุผลในวิชาคณิตศาสตร์และภาษาอังกฤษของนักเรียนชั้นมัธยมศึกษาตอนปลาย เพื่อใช้ในการเข้าศึกษาต่อยังสถาบันอุดมศึกษา ในระบบการศึกษาของสหรัฐอเมริกา และในปัจจุบันมีมหาวิทยาลัยอินเตอร์หลาย ๆ แห่ง ได้นำคะแนนสอบมา SAT มาใช้เป็นเกณฑ์อีกด้วย",
        subjects: [
          ["Basic Math", "Basic English"],
          ["Math", "English"],
        ],

        imgUrl: "./img/blog.jpg",
        href: "https://th.wikipedia.org/wiki/%E0%B9%80%E0%B8%AD%E0%B8%AA%E0%B9%80%E0%B8%AD%E0%B8%97%E0%B8%B5",
        level: ["Grade 6 - 8", "Grade 9 - 12"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนสอบ SAT I", "SAT I "],
      },
    ],
    "SAT II": [
      {
        id: 1,
        name: "SAT II",
        description:
          "SAT II คือข้อสอบวัดระดับสำหรับนักเรียนมัธยมศึกษาตอนปลายเพื่อใช้ในการสมัครเข้ามหาวิทยาลัยชั้นนำทั่วโลก โดยข้อสอบแบ่งออกเป็น 5 สาขา ได้แก่ คณิตศาสตร์ ภาษาอังกฤษ ประวัติศาสตร์ ภาษาศาสตร์ และ วิทยาศาสตร์ ซึ่งมีจำนวนทั้งหมดกว่า 20 วิชา ทั้งนี้ คะแนนแต่ละวิชาของ SAT II อยู่ระหว่าง 200 ถึง 800 คะแนน",
        subjects: [["Basic Math"], ["Math"]],

        imgUrl: "./img/blog.jpg",
        href: "https://en.wikipedia.org/wiki/SAT_Subject_Tests",
        level: ["Grade 6 - 8", "Grade 9 - 12"],
        course: ["ปูพื้นฐานและเพิ่มเกรดก่อนสอบ SAT II", "SAT II"],
      },
    ],
    หลักสูตรไทย: [
      {
        id: 1,
        name: "หลักสูตรไทย",
        description: "",
        subjects: [
          ["Math", "Science", "English"],
          ["Math", "Science", "English"],
          ["Math", "Science", "English"],
          ["Math", "Physics", "Chemistry", "Biology", "English"],
          ["TPAT1 ความถนัดทางด้านคณิตศาสตร์"],
          ["TPAT3 ความถนัดทางด้านวิศวกรรมศาสตร์"],
          ["Math", "Physics", "Chemistry", "Biology", "English"],
        ],

        imgUrl: "./img/thai_curriculum.png",
        href: "https://en.wikipedia.org/wiki/International_General_Certificate_of_Secondary_Education",
        level: ["ป. 6", "ม. 1 - 3", "ม. 3", "ม. 4 - 6", "ม. 6", "", ""],
        course: [
          "สอบเข้า ม. 1",
          "ปูพื้นฐานและเพิ่มเกรดก่อนเพื่อสอบเข้า ม. 4 รร.เตรียมอุดม, มหิดลวิทย์ ฯลฯ",
          "ตะลุยโจทย์สอบเข้า ม. 4",
          "ปูพื้นฐานและเพิ่มเกรดก่อนเพื่อสอบเข้ามหาวิทยาลัย",
          "TPAT",
          "TGAT",
          "A-LEVEL",
        ],
      },
    ],
  });

  return (
    <div>
      <div className="overflow-hidden bg-white  py-24 md:py-32">
        <div className="mx-auto max-w-screen-2xl px-6 lg:px-8">
          <div className="mx-auto max-w-7xl ">
            <h2 className="mx-auto my-5 max-w-max rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500 ">
              Our Course
            </h2>
            <p className="mx-auto text-center text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:hidden sm:text-7xl md:block xl:max-w-3xl xl:text-9xl 2xl:max-w-none ">
              <span className="text-purple-500a">คอร์สเรียน</span>ของพวกเรา
            </p>
            <p className="hidden text-center text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:block sm:text-7xl md:hidden 2xl:text-9xl ">
              <span className="text-purple-500a">คอร์สเรียน</span>ของเรา
            </p>
          </div>
          <Tab.Group>
            <div className="mx-auto max-w-7xl ">
              <div className="mx-auto w-full max-w-2xl px-2 py-8 sm:px-0">
                <Tab.List className="flex space-x-1 rounded-xl bg-slate-100 p-1">
                  {Object.keys(courses).map((category) => (
                    <Tab
                      key={category}
                      className={({ selected }) =>
                        classNames(
                          "w-full rounded-xl py-2.5  text-sm  leading-5 text-gray-800",
                          selected
                            ? "bg-white shadow-md focus:outline-none"
                            : "text-gray-400"
                        )
                      }
                    >
                      {category}
                    </Tab>
                  ))}
                </Tab.List>
              </div>
            </div>

            <Tab.Panels className="mt-2">
              {Object.values(courses).map((course) => (
                <Tab.Panel className={classNames("rounded-xl bg-white sm:p-3")}>
                  {course.map((item, idx1) => (
                    <div className="grid gap-8 lg:grid-cols-2">
                      {item.name === "หลักสูตรไทย" ? (
                        <div className="col-span-2">
                          <div className="rounded-3xl bg-slate-100 p-5 sm:p-10 ">
                            <p className="my-6 text-4xl font-extrabold text-gray-800 sm:text-5xl 2xl:text-6xl">
                              คอร์สเรียนของ{" "}
                              <span className="text-purple-500">
                                {item.name}
                              </span>
                            </p>

                            <div className="overflow-hidden rounded-xl bg-white shadow sm:rounded-3xl">
                              <dl>
                                <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                                  {/*  */}
                                  <dt className="hidden text-2xl font-bold  text-gray-900 sm:inline">
                                    ระดับชั้นเรียน
                                  </dt>
                                  <dd className="mt-1 hidden text-2xl font-bold  text-gray-900 sm:col-span-2 sm:mt-0 sm:inline">
                                    คอร์สเรียน
                                  </dd>
                                  {/* sm */}
                                  <dt className=" text-2xl font-bold  text-gray-900 sm:hidden">
                                    คอร์สเรียนตามระดับชั้น
                                  </dt>
                                </div>
                                {item.level.map((level, idx) => (
                                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-0 sm:px-6">
                                    <dt className="text-2xl font-bold text-gray-800">
                                      {level}
                                    </dt>
                                    <dd className="mt-1 text-2xl text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item.course[idx]}
                                      <div>
                                        {item.subjects[idx].map(
                                          (subject, id) => (
                                            <div
                                              className={`mx-1 my-1 inline-block rounded-lg bg-${subject} p-2 text-xl font-extrabold text-white ease-in-out duration-100 cursor-pointer hover:scale-105`}
                                              onClick={() => {
                                                setSelectedItem(subject);
                                                setType("subject");
                                                setOpenDialog(true);
                                              }}
                                            >
                                              <GoPrimitiveDot className="inline" />{" "}
                                              {subject}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </dd>
                                  </div>
                                ))}
                              </dl>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="hidden rounded-3xl bg-slate-100 p-5 sm:p-10 lg:block ">
                            <p className="my-6 text-4xl font-extrabold text-gray-800 sm:text-5xl 2xl:text-6xl">
                              <span className="text-purple-500">
                                {item.name}{" "}
                              </span>
                              คืออะไร ?
                            </p>
                            <h1 className="my-6 hidden text-xl text-gray-500 sm:inline sm:text-2xl">
                              {item.description}
                            </h1>
                            <h1 className=" my-6 text-xl text-gray-500 sm:hidden sm:text-2xl">
                              {item.description.substring(0, 200)}...
                            </h1>

                            <a
                              href={item.href}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <p className="max-w-max border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:mt-10 sm:p-5 ">
                                ศึกษาเพิ่มเติม &nbsp;
                                <HiArrowUpRight className="inline" />
                              </p>
                            </a>
                          </div>
                          <div>
                            <div className="rounded-3xl bg-slate-100 p-5 sm:p-8">
                              <div className="overflow-hidden rounded-xl bg-white shadow sm:rounded-3xl">
                                <dl>
                                  <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 lg:grid-cols-1 xl:grid-cols-3">
                                    {/*  */}
                                    <dt className="hidden text-2xl font-bold text-gray-900 sm:inline  lg:hidden xl:block">
                                      ระดับชั้นเรียน
                                    </dt>
                                    <dd className="mt-1 hidden text-2xl font-bold text-gray-900 sm:col-span-2  sm:mt-0 sm:inline lg:hidden xl:block">
                                      คอร์สเรียน
                                    </dd>
                                    {/* sm */}
                                    <dt className=" text-2xl font-bold text-gray-900 sm:hidden  lg:block xl:hidden">
                                      คอร์สเรียนตามระดับชั้น
                                    </dt>
                                  </div>
                                  {item.level.map((level, idx2) => (
                                    <div className="border-b border-gray-200 bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:border-0 sm:px-6 lg:grid-cols-1 lg:border-b xl:grid-cols-3">
                                      <dt className="text-2xl font-bold text-gray-800">
                                        {level}
                                      </dt>
                                      <dd className="mt-1 text-2xl text-gray-700 sm:col-span-2 sm:mt-0">
                                        {item.course[idx2]}
                                        <div>
                                          {item.subjects[idx2].map(
                                            (subject, id) => (
                                              <div
                                                className={`mx-1 my-1 inline-block rounded-lg bg-${subject} p-2 text-xl font-extrabold text-white ease-in-out duration-100 cursor-pointer hover:scale-105`}
                                                onClick={() => {
                                                  setSelectedItem(subject);
                                                  setType("subject");
                                                  setOpenDialog(true);
                                                }}
                                              >
                                                <GoPrimitiveDot className="inline" />{" "}
                                                {subject}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      </dd>
                                    </div>
                                  ))}
                                </dl>
                              </div>
                            </div>
                          </div>
                          <div className=" rounded-3xl bg-slate-100 p-5 sm:p-10 lg:hidden ">
                            <p className="my-6 text-4xl font-extrabold text-gray-800 sm:text-5xl 2xl:text-6xl">
                              <span className="text-purple-500">
                                {item.name}{" "}
                              </span>
                              คืออะไร ?
                            </p>
                            <h1 className="my-6 hidden text-xl text-gray-500 sm:inline sm:text-2xl">
                              {item.description}
                            </h1>
                            <h1 className=" my-6 text-xl text-gray-500 sm:hidden sm:text-2xl">
                              {item.description.substring(0, 200)}...
                            </h1>

                            <a
                              href={item.href}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <p className="max-w-max border border-gray-800 bg-gray-800 p-3 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-slate-100 hover:text-gray-800 sm:mt-10 sm:p-5 ">
                                ศึกษาเพิ่มเติม &nbsp;
                                <HiArrowUpRight className="inline" />
                              </p>
                            </a>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>

      <div className="bg-white py-32 ">
        <div className="mx-auto grid max-w-screen-2xl px-6  lg:px-8 xl:grid-cols-2">
          <div className="hidden xl:block">
            <img src="./img/banner3.jpg" className="rounded-3xl" alt="" />
          </div>
          <div className="mx-auto sm:max-w-lg md:max-w-none 2xl:max-w-xl ">
            <h2 className="  my-5 max-w-max  rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500">
              Learning Method
            </h2>
            <p className="mt-2 max-w-4xl text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl md:max-w-lg 2xl:text-8xl">
              วิธีการเรียนกับ กาลิเลโอ ติวเตอร์
            </p>
            <img
              src="./img/banner3.jpeg"
              className="my-10 rounded-3xl xl:hidden"
              alt=""
            />

            <Link to="/teaching-example">
              <p className="inline-block border border-gray-800 bg-gray-800 p-5 text-2xl leading-tight text-white duration-200 ease-in-out hover:bg-white hover:text-gray-800 xl:mt-10 ">
                ตัวอย่างการเรียน &nbsp;
                <HiArrowUpRight className="inline" />
              </p>
            </Link>
          </div>
        </div>
      </div>

      <div className="bg-white pt-10 pb-32 ">
        <div className="mx-auto px-6 lg:px-8 xl:max-w-6xl 2xl:max-w-screen-2xl">
          <h2 className="  my-5 max-w-max  rounded-full bg-slate-100 px-5 py-1 text-2xl font-extrabold  text-purple-500">
            Pros
          </h2>
          <p className="mt-2 hidden text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:block sm:text-7xl lg:max-w-2xl 2xl:max-w-4xl 2xl:text-8xl">
            เรียนกับ กาลิเลโอ ติวเตอร์ ดีอย่างไร
          </p>
          <p className="mt-2 max-w-4xl text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:hidden sm:text-8xl">
            เรียนกับเราดีอย่างไร ?
          </p>
        </div>
        <div className="mx-auto mt-7 grid px-10 sm:grid-cols-2  sm:gap-5 xl:px-20  2xl:grid-cols-4 ">
          {features.map((feature) => (
            <div
              key={feature.name}
              className="my-2 rounded-3xl bg-slate-100  p-10"
            >
              <feature.icon
                className="mx-auto h-20 w-20 text-purple-600"
                aria-hidden="true"
              />
              <dt className="text-base  leading-7 text-gray-800">
                <h3 className=" mx-auto mt-10 text-center text-2xl font-bold text-gray-800 sm:text-4xl">
                  {feature.name}
                </h3>
                <p className="mx-auto mt-7 max-w-md text-xl text-gray-500 sm:text-center">
                  {feature.description}
                </p>
              </dt>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-slate-100 py-24 sm:py-32 ">
        <div className="mx-auto grid max-w-screen-2xl px-6 sm:gap-20 md:grid-cols-1  lg:px-8 xl:grid-cols-3">
          <div>
            <h2 className="  my-5 max-w-max  rounded-full bg-white px-5 py-1 text-2xl font-extrabold  text-purple-500">
              Courses
            </h2>
            <p className="mt-2 max-w-2xl text-6xl font-extrabold leading-tight tracking-tight text-gray-800 sm:text-7xl 2xl:text-8xl">
              รูปแบบการเรียน
            </p>
            <p className="mt-8 max-w-xl text-3xl text-gray-500">
              น้องๆ สามารถเลือกเรียนในรูปแบบที่สนใจและเหมาะกับตัวเอง
            </p>
          </div>
          <div className="col-span-2 mt-10 grid gap-4 sm:mt-0 md:grid-cols-2">
            <div className="rounded-3xl border-2 border-purple-500 bg-white p-6 shadow-md sm:p-10">
              <h1 className="mt-5 text-4xl font-extrabold text-purple-500 sm:text-5xl xl:text-4xl 2xl:text-5xl">
                <BsFillPersonFill className="mr-4 inline text-5xl" />
                เรียนตัวต่อตัว
              </h1>
              <ul className="py-5 text-xl">
                <li className="py-2">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  เลือกบทเรียนตามต้องการ
                </li>
                <li className="py-2">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  เลือกครูสไตล์ที่ชอบ
                </li>
                <li className="py-2">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  จัดตารางเรียนได้เอง
                </li>
                <li className="py-2 opacity-0 ">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  จัดตารางเรียนได้เอง
                </li>
              </ul>
              <a
                href="https://line.me/R/ti/p/@efj7400q"
                target="_blank"
                rel="noreferrer"
              >
                <p className="rounded-xl bg-purple-500 py-3 text-center text-xl font-bold text-white">
                  สอบถามเพิ่มเติม
                </p>
              </a>
            </div>
            <div className="mt-10 rounded-3xl bg-white p-6 shadow-md sm:mt-0 sm:p-10">
              <h1 className="mt-5 text-4xl font-extrabold text-gray-700 xl:text-4xl 2xl:text-5xl">
                <BsFillPeopleFill className="mr-4 inline text-5xl" />
                เรียนเป็นคู่
              </h1>
              <ul className="py-5 text-xl">
                <li className="py-2">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  เลือกบทเรียนตามต้องการ
                </li>
                <li className="py-2">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  เลือกครูสไตล์ที่ชอบ
                </li>
                <li className="py-2">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  จัดตารางเรียนได้เอง
                </li>
                <li className="py-2">
                  <BsCheck2 className="mr-4 inline text-2xl" />{" "}
                  จับคู่เรียนกับเพื่อน
                </li>
              </ul>
              <a
                href="https://line.me/R/ti/p/@efj7400q"
                target="_blank"
                rel="noreferrer"
              >
                <p className="rounded-xl bg-gray-700 py-3 text-center text-xl font-bold text-white">
                  สอบถามเพิ่มเติม
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={openDialog}
        selectedItem={selectedItem}
        type={type}
        handleClose={() => {
          setOpenDialog(false);
          setSelectedItem({});
        }}
      />
      <CTA />
      <Footer />
    </div>
  );
}
